interface ScheduleIconProps {
  className?: string;
}

export const ScheduleIcon = ({ className }: ScheduleIconProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30px"
    height="30px"
  >
    <path d="M9,2C8.448,2,8,2.448,8,3v1H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6 c0-1.105-0.895-2-2-2h-2V3c0-0.552-0.448-1-1-1s-1,0.448-1,1v1H10V3C10,2.448,9.552,2,9,2z M6,10h18v14H6V10z M9,13 c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S9.552,13,9,13z M14,13c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1 S14.552,13,14,13z M19,13c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S19.552,13,19,13z M9,18c-0.552,0-1,0.448-1,1s0.448,1,1,1 s1-0.448,1-1S9.552,18,9,18z M14,18c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S14.552,18,14,18z M19,18c-0.552,0-1,0.448-1,1 s0.448,1,1,1s1-0.448,1-1S19.552,18,19,18z" />
  </svg>
);
